import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";
import menuImage from "../../../assets/images/menu.png";
import { useCheckObjectDepth } from "../../../helpers/hooks/useCheckObjectDepth";
import { withRouter } from "react-router";
import CONSTANTS from "../../../config/constants";
import { mediaUrl } from "../../../../core/helpers/CoreHelpers";
import _ from "lodash";

const Menu = ({ contentFields, width, router, relatedContents }) => {

    let objectDepth;

    const getContentFieldValue = (fieldDefinitionKey, contents = false) => {
        const items = contents ? contents : contentFields;
        const data = _.find(items, { fieldDefinitionKey: fieldDefinitionKey });

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false;
    };

    const getBlockWidth = () => {
        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (
                getContentFieldValue("Width") &&
                getContentFieldValue("Width") !==
                    CONSTANTS.BLOCK_DEFAULT_WIDTH &&
                getContentFieldValue("Width") !== w
            ) {
                w = getContentFieldValue("Width");
            }
        }

        return w;
    };

    getBlockWidth();

    const openLink = (e, item) => {
        e.preventDefault();
        e.stopPropagation();

        if (item.data.link) {
            if (item.data.link.contentId) {
                router.push(`/page/${item.data.link.contentId}`);
            } else {
                if (item.data.linkTarget) {
                    window.open(item.data.link.url, "_blank");
                } else {
                    window.location.href = item.data.link.url;
                }
            }
        }
    };

    const addMenuClass = () => {
        return `menu-tier-${objectDepth}`;
    };

    const renderChildren = (children) => {
        if (children.length > 0) {
            return (
                <ul>
                    {children.map((item) => {
                        if (item.status === 1) {
                            return (
                                <li
                                    key={item.data.title}
                                    onClick={(e) => openLink(e, item)}
                                >
                                    <span>
                                        {item.data.title}{" "}
                                        {item.children.length > 0 && (
                                            <FontAwesomeIcon
                                                icon={faChevronRight}
                                            />
                                        )}
                                    </span>
                                    {renderChildren(item.children)}
                                </li>
                            );
                        }

                        return null;
                    })}
                </ul>
            );
        }

        return null;
    };

    const renderMegaMenu = (item, image) => {
        if (item.status === 1) {
            return (
                <div className={`mega-menu ${addMenuClass()}`}>
                    <div className="image">
                        {image ? (
                            <img src={mediaUrl(image)} alt={item.data.title} />
                        ) : (
                            <img src={menuImage} alt={item.data.title} />
                        )}
                    </div>
                    <div className="sub-menu">
                        {renderChildren(item.children)}
                    </div>
                    <div className="image">
                        {image ? (
                            <img src={mediaUrl(image)} alt={item.data.title} />
                        ) : (
                            <img src={menuImage} alt={item.data.title} />
                        )}
                    </div>
                </div>
            );
        }
    };

    const renderMenuTopLevelItem = (item, image) => {
        const hasChildren = item.children.length > 0;

        if (item.status === 1) {
            useCheckObjectDepth(item.children);
            return (
                <li
                    key={item.id}
                    onClick={(e) => openLink(e, item)}
                    className={`
                        ${hasChildren > 0 ? "has-children" : "no-children"}
                        ${objectDepth === 1 ? "tooltip" : ""}
                        ${
                            parseInt(router.params.page, 10) ===
                            (item.data.link && item.data.link.contentId)
                                ? "active"
                                : ""
                        }
                    `}
                >
                    <span>
                        {item.data.title}{" "}
                        {hasChildren && (
                            <FontAwesomeIcon icon={faChevronDown} />
                        )}
                    </span>
                    {hasChildren && renderMegaMenu(item, image)}
                </li>
            );
        }
    };

    return (
        <div className="menu">
            <ul>
                {relatedContents[0].children.map((item) =>
                    renderMenuTopLevelItem(
                        item,
                        relatedContents[0].image
                    )
                )}
            </ul>
        </div>
    );
}

export default withRouter(Menu);



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/MenuBlock/MenuBlock.js